export default __webpack_public_path__ + "static/media/circuitcourt.210461ed.png";